import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';

const FOOTER_LINKS = [
  { label: 'Privacy Policy', to: '/privacy' },
  { label: 'Terms of Service', to: '/terms' },
  { label: 'Refund Policy', to: '/refund' },
  { label: 'Contact Us', to: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-[#060A12] border-t border-slate-800/60 py-10">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-6">

          <Link to="/">
            <img src={logo} alt="LocalContact" className="h-7 w-auto object-contain" />
          </Link>

          <ul className="flex flex-wrap gap-6">
            {FOOTER_LINKS.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  className="text-[13px] text-slate-500 hover:text-slate-200 transition-colors duration-150 font-medium"
                >
                  {link.label}
                </Link>
              </li>
            ))}
            {/* <li>
              <a
                href="mailto:support@localcontact.ai"
                className="text-[13px] text-slate-500 hover:text-slate-200 transition-colors duration-150 font-medium"
              >
                Contact
              </a>
            </li> */}
          </ul>

          <div className="flex items-center gap-3">
            <a
              href="https://www.linkedin.com/in/adnanmanna/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LocalContact on LinkedIn"
              className="w-8 h-8 rounded-lg bg-slate-800 border border-slate-700 flex items-center justify-center text-slate-400 hover:bg-[#0077b5] hover:border-[#0077b5] hover:text-white hover:scale-110 transition-all duration-150"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
          </div>

          <span className="text-[12px] text-slate-600 w-full sm:w-auto">
            &copy; {new Date().getFullYear()} LocalContact. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}
